import React, { useState, useEffect, useCallback } from 'react';
import { useHistory } from "react-router-dom";

import { classNames } from 'primereact/utils';
import { showToast } from "../ToastManager";
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from "primereact/dialog";

import UsuarioService from '../../service/UsuarioService';

const usuarioService = new UsuarioService(); // Create an instance of UsuarioService

const ListarUsuarios = () => {
    const [usuario, setUsuarios] = useState(null);
    const [filters1, setFilters1] = useState(null);
    const [loading1, setLoading1] = useState(false);
    const history = useHistory();
    const [deleteDialog, setDeleteDialog] = useState(false);
    const [activeDialog, setActiveDialog] = useState(false);
    const [toDelete, setToDelete] = useState(null);
    const [toActive, setToActive] = useState(null);

    const iss = localStorage.getItem('iss');
    let roles = JSON.parse(localStorage.getItem('roles'));

    const initUsuarios = useCallback(() => {
        setLoading1(true);
        usuarioService.listAllUsers(iss)
            .then(data => {
                if (data.data && data.data.rows) {
                    const usuariosAtivos = data.data.rows.filter(user => !user.excluido);
                    setUsuarios(usuariosAtivos);
                }
                setLoading1(false);
            })
            .catch(error => {
                console.error('Erro ao carregar usuários:', error);
                setLoading1(false);
            });
    }, [iss])

    const initFilters1 = useCallback(() => {
        setFilters1({
            'nome': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
            'email': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
            /* 'login.email': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] }, */
        });
    }, []);

    useEffect(() => {
        if (!usuario) {
            initFilters1();
            initUsuarios();
        }
    }, [initFilters1, initUsuarios, usuario]);

    const irParaCadastro = () => {
        if (roles.postUser)
            history.push('/usuarios/cadastrar');
    }

    const abreModalDeletar = (usuario) => {
        setToDelete(usuario);
        setDeleteDialog(true);
    }

    const abreModalAtivar = (usuario) => {
        console.log(usuario);
        setToActive(usuario);
        setActiveDialog(true);
    }

    const handleDeleteUsuario = () => {
        if (roles.deleteUser) {
            setLoading1(true)
            usuarioService.deleteUser(iss, toDelete.id).then(() => {
                showToast({ severity: 'success', summary: 'Sucesso', detail: 'Usuario excluído com sucesso' });
                setLoading1(false);
                hideModalDeletar();
                initUsuarios();
            });
        }
    }

    const handleActiveUsuario = () => {
        if (roles.activeUser) {
            setLoading1(true)
            let status = toActive.ativo ? 0 : 1;
            usuarioService.activeUser(iss, toActive.id, status).then(() => {
                showToast({ severity: 'success', summary: 'Sucesso', detail: `Usuario ${status ? 'ativado' : 'desativado'} com sucesso` });
                setLoading1(false);
                hideModalActive();
                initUsuarios();
            });
        }
    }

    const visualizar = (toEdit) => {
        if (roles.getUser)
            history.push('/usuarios/visualizar/' + toEdit.id);
    }

    const hideModalDeletar = () => {
        setDeleteDialog(false);
        setToDelete(null);
    }

    const hideModalActive = () => {
        setActiveDialog(false);
        setToActive(null);
    }

    const opcoesBody = (rowData) => {
        return <span style={{ display: 'flex', justifyContent: 'space-between' }}>
            {roles.deleteUser ? <Button icon="pi pi-trash" onClick={() => { abreModalDeletar(rowData) }} style={{ backgroundColor: 'red', borderColor: 'red' }} className="p-button-rounded mr-2 mb-2" /> : <></>}
            {roles.getUser ? <Button icon="pi pi-eye" onClick={() => { visualizar(rowData) }} className="p-button-rounded  mr-2 mb-2" /> : <></>}
        </span>
    }

    const statusBody = (rowData) => {
        return roles.activeUser ? <Button icon={rowData.ativo ? 'pi pi-check' : 'pi pi-times'} onClick={() => { abreModalAtivar(rowData) }} className="p-button-rounded  mr-2 mb-2" style={{ backgroundColor: rowData.ativo ? 'green' : 'red', color: 'black' }} /> : <></>
        // return <i className={classNames('pi', { 'text-green-500 pi-check-circle': rowData.ativo, 'text-pink-500 pi-times-circle': !rowData.ativo })}></i>;
    }

    const deleteDialogFooter = (
        <>
            <Button loading={loading1} label="Não" icon="pi pi-times" className="p-button-text" onClick={hideModalDeletar} />
            <Button loading={loading1} label="Sim" icon="pi pi-check" className="p-button-text" onClick={handleDeleteUsuario} />
        </>
    );

    const activeDialogFooter = (
        <>
            <Button loading={loading1} label="Não" icon="pi pi-times" className="p-button-text" onClick={hideModalActive} />
            <Button loading={loading1} label="Sim" icon="pi pi-check" className="p-button-text" onClick={handleActiveUsuario} />
        </>
    );

    return (
        <div className="grid table-demo">
            <div className="col-12">
                {roles.postUser ? <Button label="Cadastrar" onClick={irParaCadastro} className="mr-2 mb-2"></Button> : <></>}
                <div className="card">
                    <h5>Usuários</h5>
                    <DataTable value={usuario} paginator className="p-datatable-gridlines" showGridlines rows={10}
                        dataKey="id" filters={filters1} filterDisplay="menu" loading={loading1} responsiveLayout="scroll"
                        emptyMessage="Nenhuma usuário cadastrado.">
                        <Column sortable field="username" header="Nome de Usuário" filter filterPlaceholder="Procurar por nome" style={{ minWidth: '12rem' }} />
                        <Column sortable field="email" header="Email" filter filterPlaceholder="Procurar por Email" style={{ minWidth: '12rem' }} />
                        <Column sortable field="profile.cpf" header="CPF" filter filterPlaceholder="Procurar por CPF" style={{ minWidth: '12rem' }} />
                        <Column sortable field="profile.cnpj" header="CNPJ" filter filterPlaceholder="Procurar por CNPJ" style={{ minWidth: '12rem' }} />
                        <Column sortable field="profile.phone" header="Telefone" filter filterPlaceholder="Procurar por Telefone" style={{ minWidth: '12rem' }} />
                        <Column sortable field="ativo" body={statusBody} header="Ativo" style={{ width: '1rem' }} />
                        <Column header="Opções" body={opcoesBody} style={{ width: '8rem' }} />
                    </DataTable>
                </div>
            </div>

            <Dialog visible={deleteDialog} style={{ width: '450px' }} header="Deletar" modal footer={deleteDialogFooter} onHide={hideModalDeletar}>
                <div className="flex align-items-center justify-content-center">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                    <span>Tem certeza que deseja deletar o usuário selecionado?</span>
                </div>
            </Dialog>

            <Dialog visible={activeDialog} style={{ width: '450px' }} header="Ativar/Desativar" modal footer={activeDialogFooter} onHide={hideModalActive}>
                <div className="flex align-items-center justify-content-center">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                    <span>Tem certeza que deseja ativar/destivar o usuário selecionado?</span>
                </div>
            </Dialog>
        </div>

    );
}

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(ListarUsuarios, comparisonFn);
